import { render, staticRenderFns } from "./systemAutoSubstitutingReport.vue?vue&type=template&id=2c310952&scoped=true&"
import script from "./systemAutoSubstitutingReport.vue?vue&type=script&lang=js&"
export * from "./systemAutoSubstitutingReport.vue?vue&type=script&lang=js&"
import style0 from "./systemAutoSubstitutingReport.vue?vue&type=style&index=0&id=2c310952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c310952",
  null
  
)

component.options.__file = "systemAutoSubstitutingReport.vue"
export default component.exports